<template>
  <div>
    <v-form ref="refMain">
      <v-container fluid>
        <v-row fluid>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-autocomplete v-model="dOrgId" label="* Unidad de Negocio"
                            :items="dOrg"  item-value="IdCentProd" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="3" sm="3" md="3" lg="3" class="pa-1">
            <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                            :items="dPriServicios"  item-value="IdServicio" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="3" sm="3" md="3" lg="3" class="pa-1">
            <v-autocomplete v-model="dPeriodo" label="* Periodo"
                            :items="dMatPeriodos"  item-value="IdPeriodo" item-text="Periodo"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="3" sm="3" md="3" lg="3" class="pa-1">
            <v-autocomplete v-model="dIdSeccion" label="* Sección"
                            :items="dMATSECCIONES"  item-value="IdSeccion" item-text="Seccion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" chips clearable deletable-chips small-chips :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="1" md="1" lg="1" class="pa-1">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-card-title v-if="dPriAlumnos.length > 0">
        <v-spacer></v-spacer>
        <v-text-field
            v-if="dTable.searchVisible"
            v-model="dTable.search"
            prepend-icon="search"
            label="Filtrar por ..."
            single-line
            dense
            hide-details
        ></v-text-field>
        <v-select v-model="dFiltroDeuda" label="Filtrar por Nro Deuda" outlined dense hide-details
                  :items="[{text: 'Todos', value: ''},
                            {text: 'solo 1', value: '#1'},
                            {text: 'solo 2', value: '#2'},
                            {text: 'solo 3', value: '#3'},
                            {text: 'solo 4', value: '#4'},
                            {text: 'solo 5', value: '#5'},
                            {text: '1 a mas', value: '%1'},
                            {text: '2 a mas', value: '%2'},
                            {text: '3 a mas', value: '%3'},
                            {text: '4 a mas', value: '%4'}]">
        </v-select>
      </v-card-title>
      <v-data-table
          v-model="dTable.selected"
          :headers="dTable.headers"
          :items="dPriAlumnos"
          :loading="dTable.loading"
          :search="dTable.search"
          item-key="IdMatricula"
          show-select
          class="elevation-1"
          :items-per-page="-1">
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
        <template v-slot:[`item.Alumno`]="{ item }">
          <span>{{item.Alumno}} <v-chip v-if="item.modalidad" color="warning" dark>{{item.modalidad}}</v-chip></span>
        </template>
        <template v-slot:[`item.Seccion`]="{ item }">
          <span>{{item.Anio}}-{{item.Periodo}} {{item.Nivel}}{{item.Seccion}}</span>
        </template>
        <template v-slot:[`item.Bloqueado`]="{ item }">
          <div v-if="item.prialumnosbloqueo.length>0" class="d-flex align-center">
            <v-chip  v-if="item.prialumnosbloqueo[0].bloqueado==1" class="ma-2" color="error" outlined><v-icon left>do_disturb_off</v-icon>{{item.TipoBloqueado}}</v-chip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-divider></v-divider>
    <div class="pa-2 blue-grey darken-2">
      <v-btn color="red" class="ma-1" dark @click="fuExecute"><v-icon left>do_disturb_off</v-icon> Bloquear</v-btn>
      <v-btn color="blue-grey" class="ma-1" dark @click="fuExecuteDes"><v-icon left>do_disturb_on</v-icon> DesBloquear</v-btn>

      <v-dialog v-model="dPriAlumnosBloqueoTipoModal.dialog" max-width="500">
        <template>
          <v-card>
            <v-toolbar class="justify-end" color="blue-grey" dark>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey" @click="fuCreate" :loading="dPriAlumnosBloqueoTipoModal.IsUpdating"><v-icon>do_disturb_on</v-icon> Bloquear</v-btn>
              <v-btn @click="dPriAlumnosBloqueoTipoModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text>
              <v-alert dense text type="info">
                Ha seleccionado <strong>{{this.dTable.selected.length}}</strong> alumnos
              </v-alert>
              <v-autocomplete label="Tipo de bloqueo:" v-model="dPriAlumnosBloqueoTipoId"
                              :items="dPriAlumnosBloqueoTipos" item-value="id" item-text="tipo"
                              filled prepend-inner-icon="invert_colors"></v-autocomplete>
            </v-card-text>
          </v-card>
        </template>
      </v-dialog>
    </div>
    <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
      <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  name: 'PriAlumnosBloqueoDeudaForm',
  data: () => ({
    dIsUpdating: false,
    dMatPeriodos: [],
    dMATSECCIONES: [],
    dPriAlumnos: [],
    dPriAlumnosBloqueoTipoId: '1',
    dPriAlumnosBloqueoTipos: [],
    dPriAlumnosBloqueoTipoModal: {
      dialog: false,
      IsUpdating: false,
    },
    dPriServicios: [],
    dMatSeccionesPeriodoServicio: [],
    dSearch: {
      IdServicio: '',
      Periodo: '',
      IdSeccion: '',
      NroDeuda: 1,
    },
    dIdSeccion: '',
    dIdServicio: '',
    dOrgId: '',
    dPeriodo: '',
    dOrg: [],
    dSnackbar: false,
    dTable: {
      headers: [
        //{value: 'actions', text: '...', sortable: false},
        {value: 'IdMatricula', text: 'IdMatricula', align: ' d-none'},
        {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
        {value: 'Seccion', text: 'Seccion'},
        {value: 'Alumno', text: 'Alumno'},
        {value: 'Codigo', text: 'Codigo'},
        {value: 'FechaMatricula', text: 'F. Matricula'},
        {value: 'count', text: 'Nro Deuda'},
        {value: 'count2', text: 'Nro Deuda2', align: ' d-none'},
        {value: 'count3', text: 'Nro Deuda3', align: ' d-none'},
        {value: 'Bloqueado', text: 'Bloqueado'},
      ],
      loading: false,
      search: null,
      searchVisible: true,
      selected: []
    },
    dFiltroDeuda: '',
  }),
  computed: {
    ...mapState(['ssUser']),
  },
  watch: {
    'dOrgId' (val) {
      this.fuLoad(val);
    },
    'dIdServicio' (val) {
      this.dSearch.Periodo = '';
      this.dSearch.IdSeccion = '';
      this.dMatPeriodos = [];
      this.dMATSECCIONES = [];

      this.dMatSeccionesPeriodoServicio.map(item => {
        if(val==item.IdServicio){
          this.dMatPeriodos.push({
            IdPeriodo : item.Periodo,
            Periodo : item.Periodo
          });
          return true;
        }
      });
      this.dMatPeriodos = [...new Map(this.dMatPeriodos.map(item => [item['IdPeriodo'], item])).values()];
    },
    'dPeriodo' (val) {
      if(val != ''){
        this.dMATSECCIONES = [];

        this.dMatSeccionesPeriodoServicio.map(item => {
          if(this.dIdServicio==item.IdServicio && val == item.Periodo && item.Seccion != 'X'){
            this.dMATSECCIONES.push({
              IdSeccion: item.IdSeccion,
              Seccion: item.Nivel+item.Seccion+"-"+ item.Turno +"-F.Inicio:" + item.FechaInicio.substr(0, 10),
              FechaInicio: item.FechaInicio,
            });
            return true;
          }
        });
        this.dMATSECCIONES = this.dMATSECCIONES.sort((p1, p2) => (p1.FechaInicio < p2.FechaInicio) ? -1 : (p1.FechaInicio > p2.FechaInicio) ? 1 : 0);
      }
    },
    dFiltroDeuda (val) {
      this.dTable.search = val;

      if(val=='')
        this.dTable.searchVisible = true;
      else
        this.dTable.searchVisible = false;
    },
    'dTable.search' (val) {
      if (val=='') {
        this.dFiltroDeuda = '';
      }
    }
  },
  mounted(){
    this.Usuario = JSON.parse(localStorage.getItem('ssUser'))
    this.fuLoadOrg(this.Usuario)
    // this.fuLoad(this.dOrgId);

  },
  methods: {
    async fuLoad(Unidad){
      const response = await this.$apollo.query({
        query: gql`query priservicioByIdCentroProdByActivo($IdCentroProd: Int!){
                    priservicioByIdCentroProdByActivo (IdCentroProd: $IdCentroProd, Activo: 1){
                      IdServicio
                      Descripcion
                    }
                }`,
        variables: {
          IdCentroProd: Unidad
        }
      })
      this.dPriServicios = response.data.priservicioByIdCentroProdByActivo;
      // const response2 = await this.$apollo.query({
      //     query: gql`{
      //         matseccionByConcluyo0{
      //             IdSeccion
      //             Seccion
      //             FechaInicio
      //             Turno
      //             HoraTurno
      //             matperiodo{
      //                 IdPeriodo
      //                 Anio
      //                 Periodo
      //                 Nivel
      //                 priservicio{
      //                     IdServicio
      //                     Descripcion
      //                 }
      //             }
      //         }
      //         prialumnosbloqueotipoByactivo(activo:1){
      //             id
      //             tipo
      //         }
      //     }`
      // })
      const response2 = await this.$apollo.query({
        query: gql`query matseccionesListarCentProd($IdCentroProd: Int!){
              matseccionesListarCentProd(IdCentroProd: $IdCentroProd){
                  IdSeccion
                  Nivel
                  Seccion
                  Turno
                  FechaInicio
                  FechaFin
                  Anio
                  Periodo
                  IdServicio
                  Descripcion
              }
          }`,
        variables: {
          IdCentroProd: Unidad
        }
      })

      // Arreglo de Servicios y Periodos
      this.dMatSeccionesPeriodoServicio = response2.data.matseccionesListarCentProd.map(item => {
          let vItem = {
            IdServicio : item.IdServicio,
            Descripcion : item.Descripcion,
            IdPeriodo : item.Periodo,
            Periodo : item.Anio +'-'+ item.Periodo,
            Nivel : item.Nivel,
            IdSeccion: item.IdSeccion,
            Seccion: item.Seccion,
            FechaInicio: item.FechaInicio,
            Turno: item.Turno
          }
          return vItem;
      });
    },
    async fuLoadOrg(User){
      const response = await this.$apollo.query({
        query: gql`query centProdLmsUsuario($Usuario: String!){
                    centProdLmsUsuario(Usuario: $Usuario){
                      IdCentProd
                      Descripcion
                      Usuario
                    }
                    prialumnosbloqueotipoByactivo(activo:1){
                      id
                      tipo
                   }
                }`,
        variables: {
          Usuario: User.Usuario
        }
      })
      this.dOrg = response.data.centProdLmsUsuario;
      this.dPriAlumnosBloqueoTipos = response.data.prialumnosbloqueotipoByactivo;
    },
    // async fuLoad(){
    // const response = await this.$apollo.query({
    //     query: gql`{
    //         matseccionByConcluyo0{
    //             IdSeccion
    //             Seccion
    //             FechaInicio
    //             Turno
    //             HoraTurno
    //             matperiodo{
    //                 IdPeriodo
    //                 Anio
    //                 Periodo
    //                 Nivel
    //                 priservicio{
    //                     IdServicio
    //                     Descripcion
    //                 }
    //             }
    //         }
    //         prialumnosbloqueotipoByactivo(activo:1){
    //             id
    //             tipo
    //         }
    //     }`
    // })
    //
    // // Arreglo de Servicios y Periodos
    // this.dMatSeccionesPeriodoServicio = response.data.matseccionByConcluyo0.map(item => {
    //     let vItem = {
    //         IdServicio : item.matperiodo.priservicio.IdServicio,
    //         Descripcion : item.matperiodo.priservicio.Descripcion,
    //         IdPeriodo : item.matperiodo.IdPeriodo,
    //         Periodo : item.matperiodo.Anio +'-'+ item.matperiodo.Periodo,
    //         Nivel : item.matperiodo.Nivel,
    //         IdSeccion: item.IdSeccion,
    //         Seccion: item.Seccion,
    //         FechaInicio: item.FechaInicio,
    //         Turno: item.Turno,
    //         HoraTurno: item.HoraTurno,
    //     }
    //     return vItem;
    // });
    // console.log(this.dMatSeccionesPeriodoServicio);
    //
    // //NOTE: const unique = [...new.js Set(dMatSeccionesPeriodoServicio.map(item => item.Descripcion))];
    //
    // // Array unicos con servicios y ordenado
    // const arrayUniquePriServicio = [...new Map(this.dMatSeccionesPeriodoServicio.map(item => [item['IdServicio'], item])).values()];
    // this.dPriServicios = arrayUniquePriServicio.sort((p1, p2) => (p1.Descripcion < p2.Descripcion) ? -1 : (p1.Descripcion > p2.Descripcion) ? 1 : 0);
    //

    // },
    async fuSearch(){
      if(!this.$refs.refMain.validate()){
        this.dSnackbar = true;
      } else {
        this.dTable.loading = true;
        this.dTable.selected = [];
        this.dFiltroDeuda = '';
        this.dTable.search = '';
        try {
          const response = await this.$apollo.query({
            query: gql`query matalumnosbloqueoLmsCentProd($IdCentroProd: Int!,$IdSeccion:String!){
                            matalumnosbloqueoLmsCentProd(IdCentroProd: $IdCentroProd, IdSeccion: $IdSeccion){
                                IdMatricula
                                IdAlumno
                                IdSeccion
                                FechaMatricula
                                Alumno
                                Codigo
                                Anio
                                Periodo
                                Nivel
                                Seccion
                                Bloqueado
                                TipoBloqueado
                                IdModalidadAdmision
                                modalidad
                                DeudaByAlumno{
                                  Deuda
                                  FechaProg
                                }
                                prialumnosbloqueo{
                                    id
                                    bloqueado
                                    prialumnosbloqueotipo{
                                        tipo
                                    }
                                }
                            }
                        }`,
            variables: {
              IdSeccion: this.dIdSeccion,
              IdCentroProd: this.dOrgId
            },
            fetchPolicy: 'no-cache'
          })
          this.dPriAlumnos = [];
          
          const arrayPriAlumnos = response.data.matalumnosbloqueoLmsCentProd;
          this.dPriAlumnos = arrayPriAlumnos.map(item => {
            let vDeuda  = item.DeudaByAlumno;
            if (!vDeuda){
              item.count = 0;
              item.count2 = '#0';
              item.count3 = '';
            } else {
              let arrayDeuda = vDeuda.filter(x=>x.FechaProg<moment().format("YYYY-MM-DD"));
              item.count = arrayDeuda.length;
              item.count2 = '#'+arrayDeuda.length;
              switch(arrayDeuda.length) {
                case 1:
                  item.count3 = '%1';
                  break;
                case 2:
                  item.count3 = '%1%2';
                  break;
                case 3:
                  item.count3 = '%1%2%3';
                  break;
                case 4:
                  item.count3 = '%1%2%3%4';
                  break;
                case 5:
                  item.count3 = '%1%2%3%4%5';
                  break;
                default:
                  item.count3 = '';
              }
            }
            item.selector = false;
            return item;
          });
        } catch (error) {
          console.log(error);
          Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
        } finally {
          this.dTable.loading = false
        }
      }
    },
    fuExecute(){
      if(!this.dTable.selected){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        if(this.dTable.selected.length==0)
          Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
        else{
          this.dPriAlumnosBloqueoTipoModal.dialog = true;
        }
      }
    },
    fuExecuteDes(){
      if(!this.dTable.selected){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        if(this.dTable.selected.length==0)
          Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
        else{
          Swal.fire({
            title: 'Estas Seguro de Desbloquear?',
            icon: 'warning',
            showCancelButton: true,
          }).then((result) => {
            if(result.value) {
              this.fuUpdate();
            }
          });
        }
      }
    },
    async fuCreate(){
        let vIdAlumnos = this.dTable.selected.map(x=>x.IdAlumno).join(",");
        this.dPriAlumnosBloqueoTipoModal.IsUpdating = true;
        try {
            const response = await this.$apollo.mutate({
            mutation: gql`mutation create($IdCentroProd: Int!, $IdOperador: Int!, $IdTipo: Int!, $Identificador: String!){
                            matalumnobloqueocreateLmsCentProd(IdCentroProd:$IdCentroProd, IdOperador:$IdOperador, IdTipo:$IdTipo, Identificador:$Identificador){
                                success
                                message
                                data
                            }
                        }`,
            variables: {
                Identificador: vIdAlumnos,
                IdCentroProd: this.dOrgId,
                IdOperador: this.ssUser.IdPersonal,
                IdTipo: this.dPriAlumnosBloqueoTipoId
            }
            });
            if(response.data){
            this.dPriAlumnosBloqueoTipoModal.dialog = false;
            Swal.fire('Correcto', 'Se bloqueo correctamente', 'success').then(() => {
                const bloqueoTipo = this.dPriAlumnosBloqueoTipos.find(el => el.id === this.dPriAlumnosBloqueoTipoId)
                this.dTable.selected.forEach(item => {
                item.prialumnosbloqueo=[];
                item.prialumnosbloqueo.push({
                    bloqueado : 1,
                    prialumnosbloqueotipo : {
                    tipo : bloqueoTipo.tipo
                    }
                });
                });
            });
            }
        } catch (error) {
            console.log(error);
            Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
        } finally {
            this.dPriAlumnosBloqueoTipoModal.IsUpdating = false;
        }
    },
    async fuUpdate(){
      let vIdAlumnos = this.dTable.selected.map(x=>x.IdAlumno).join(",");
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation Update($IdCentroProd: Int!, $IdOperador: Int!, $Identificador: String!){
                        matalumnobloqueoupdateLmsCentProd(IdCentroProd: $IdCentroProd, IdOperador:$IdOperador, Identificador:$Identificador){
                          success
                          message
                          data
                          }
                        }`,
          variables: {
            Identificador: vIdAlumnos,
            IdCentroProd: this.dOrgId,
            IdOperador: this.ssUser.IdPersonal,
          }
        });
        if(response.data){
          console.log(response.data.matalumnobloqueoupdateLmsCentProd);
          Swal.fire('Correcto', 'Se desbloqueo correctamente', 'success').then(() => {
            this.dTable.selected.forEach(item => {
              item.prialumnosbloqueo[0].bloqueado =0;
            });
          });
        }
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      }
    }
  },
}
</script>
